<template>
    <a :href="productPageHref">
        <img
            :class="imgClass"
            :src="imgSrc('1x')"
            :srcset="imgSrcset"
            :alt="imgAlt"
        />
    </a>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useStaticAsset } from "../../functions/useStaticAsset";

const props = defineProps<{
    imgClass?: string;
    product?: any;
}>();

const { asset } = useStaticAsset();
const imgAlt = computed(
    () => `${props.product.name} (${props.product.description})`,
);
const imgSrcset = computed(
    () => `${imgSrc("1x")} 1x, ${imgSrc("2x")} 2x, ${imgSrc("3x")} 3x`,
);
const productPageHref = computed(
    () => `/products/${props.product.name.toLowerCase()}`,
);

function imgSrc(size: string) {
    const slug = props.product.slug;
    const upc = props.product.default_product_option.upc;
    const image = props.product.default_product_option.image.replace(
        "@1x",
        `@${size}`,
    );

    return asset(`/images/products/${slug}/${upc}/${image}`);
}
</script>
